export const pricingPlans = [
    {
        key: 'free',
        highlighted: false,
    },
    {
        key: 'essentiel',
        highlighted: false,
    },
    {
        key: 'pro',
        highlighted: true,
    },
    {
        key: 'premium',
        highlighted: false,
    },
]

export const featureCategories = [
    {
        key: 'booking',
        features: [
            {
                key: 'monthly_reservations',
                plans: { free: 'limit_300', essentiel: 'unlimited', pro: 'unlimited', premium: 'unlimited' },
            },
            {
                key: 'activity_creation',
                plans: { free: 'limit_2', essentiel: 'unlimited', pro: 'unlimited', premium: 'unlimited' },
            },
            {
                key: 'multi_activity_packs',
                plans: {
                    free: false,
                    essentiel: 'unlimited_feminine',
                    pro: 'unlimited_feminine',
                    premium: 'unlimited_feminine',
                },
            },
            {
                key: 'registered_customers',
                plans: {
                    free: 'unlimited_singular',
                    essentiel: 'unlimited_singular',
                    pro: 'unlimited_singular',
                    premium: 'unlimited_singular',
                },
            },
            {
                key: 'crm_access',
                plans: { free: false, essentiel: true, pro: true, premium: true },
            },
            {
                key: 'absent_tracking',
                plans: { free: false, essentiel: true, pro: true, premium: true },
            },
            {
                key: 'quote_requests',
                plans: { free: false, essentiel: false, pro: true, premium: true },
            },
            {
                key: 'additional_sales',
                plans: { free: false, essentiel: false, pro: true, premium: true },
            },
            {
                key: 'customer_export',
                plans: { free: false, essentiel: false, pro: true, premium: true },
            },
            {
                key: 'unpaid_followup',
                plans: { free: false, essentiel: false, pro: false, premium: true },
            },
        ],
    },
    {
        key: 'website',
        features: [
            {
                key: 'multi_languages',
                plans: { free: true, essentiel: true, pro: true, premium: true },
            },
            {
                key: 'custom_website',
                plans: { free: false, essentiel: true, pro: true, premium: true },
            },
            {
                key: 'booking_widget',
                plans: { free: true, essentiel: true, pro: true, premium: true },
            },
            {
                key: 'custom_domain',
                plans: { free: false, essentiel: false, pro: false, premium: true },
            },
            {
                key: 'remove_playpro_logo',
                plans: { free: false, essentiel: false, pro: false, premium: true },
            },
            {
                key: 'custom_mobile_app',
                plans: { free: false, essentiel: false, pro: 'optional', premium: true },
            },
        ],
    },
    {
        key: 'payment',
        features: [
            {
                key: 'online_payment',
                plans: { free: true, essentiel: true, pro: true, premium: true },
            },
            {
                key: 'on_site_payment',
                plans: { free: true, essentiel: true, pro: true, premium: true },
            },
            {
                key: 'deposit_percentage',
                plans: { free: false, essentiel: false, pro: true, premium: true },
            },
            {
                key: 'deposit_fixed',
                plans: { free: false, essentiel: false, pro: true, premium: true },
            },
        ],
    },
    {
        key: 'billing',
        features: [
            {
                key: 'invoice_edition',
                plans: { free: false, essentiel: true, pro: true, premium: true },
            },
            {
                key: 'quote_generation',
                plans: { free: false, essentiel: false, pro: true, premium: true },
            },
            {
                key: 'kanban_quotes',
                plans: { free: false, essentiel: false, pro: true, premium: true },
            },
            {
                key: 'brochure_with_quote',
                plans: { free: false, essentiel: false, pro: false, premium: true },
            },
            {
                key: 'deposit_management',
                plans: { free: false, essentiel: false, pro: true, premium: true },
            },
            {
                key: 'auto_quote_followup',
                plans: { free: false, essentiel: false, pro: false, premium: true },
            },
            {
                key: 'electronic_signature',
                plans: { free: false, essentiel: false, pro: false, premium: true },
            },
        ],
    },
    {
        key: 'collection',
        features: [
            {
                key: 'pos_app',
                plans: { free: false, essentiel: '1_pos', pro: '2_pos', premium: '5_pos' },
            },
            {
                key: 'offline_pos',
                plans: { free: false, essentiel: true, pro: true, premium: true },
            },
            {
                key: 'qr_code_order',
                plans: { free: false, essentiel: false, pro: false, premium: true },
            },
            {
                key: 'stock_management',
                plans: { free: false, essentiel: false, pro: false, premium: true },
            },
        ],
    },
    {
        key: 'marketing',
        features: [
            {
                key: 'promo_codes',
                plans: { free: false, essentiel: true, pro: true, premium: true },
            },
            {
                key: 'entry_books',
                plans: { free: false, essentiel: true, pro: true, premium: true },
            },
            {
                key: 'newsletters',
                plans: { free: false, essentiel: false, pro: true, premium: true },
            },
            {
                key: 'loyalty_programs',
                plans: { free: false, essentiel: false, pro: true, premium: true },
            },
            {
                key: 'gift_cards',
                plans: { free: false, essentiel: false, pro: true, premium: true },
            },
            {
                key: 'cse_ticketing',
                plans: { free: false, essentiel: false, pro: true, premium: true },
            },
            {
                key: 'events_tracking',
                plans: { free: false, essentiel: false, pro: false, premium: true },
            },
            {
                key: 'subscriptions',
                plans: { free: false, essentiel: false, pro: false, premium: true },
            },
            {
                key: 'wallet',
                plans: { free: false, essentiel: false, pro: false, premium: true },
            },
            {
                key: 'referral_program',
                plans: { free: false, essentiel: false, pro: false, premium: 'soon' },
            },
            {
                key: 'dynamic_pricing',
                plans: { free: false, essentiel: false, pro: false, premium: 'soon' },
            },
        ],
    },
    {
        key: 'automation',
        features: [
            {
                key: 'advanced_stats',
                plans: { free: false, essentiel: true, pro: true, premium: true },
            },
            {
                key: 'auto_emails',
                plans: { free: false, essentiel: false, pro: true, premium: true },
            },
            {
                key: 'karafun_integration',
                plans: { free: false, essentiel: false, pro: true, premium: true },
            },
            {
                key: 'google_calendar_sync',
                plans: { free: false, essentiel: false, pro: true, premium: true },
            },
            {
                key: 'booking_api',
                plans: { free: false, essentiel: false, pro: false, premium: true },
            },
            {
                key: 'mcp_server',
                plans: { free: false, essentiel: false, pro: false, premium: true },
            },
            {
                key: 'custom_email_server',
                plans: { free: false, essentiel: false, pro: false, premium: true },
            },
            {
                key: 'multi_establishment',
                plans: { free: false, essentiel: false, pro: false, premium: 'soon' },
            },
        ],
    },
    {
        key: 'team',
        features: [
            {
                key: 'employee_accounts',
                plans: { free: 'limit_1', essentiel: 'unlimited', pro: 'unlimited', premium: 'unlimited' },
            },
            {
                key: 'employee_permissions',
                plans: { free: false, essentiel: true, pro: true, premium: true },
            },
            {
                key: 'team_planning',
                plans: { free: false, essentiel: false, pro: true, premium: true },
            },
        ],
    },
    {
        key: 'support',
        features: [
            {
                key: 'ai_assistant',
                plans: { free: true, essentiel: true, pro: true, premium: true },
            },
            {
                key: 'email_support',
                plans: { free: false, essentiel: false, pro: true, premium: true },
            },
            {
                key: 'whatsapp_support',
                plans: { free: false, essentiel: false, pro: false, premium: true },
            },
        ],
    },
    {
        key: 'complementary_services',
        features: [
            {
                key: 'onboarding_training',
                plans: { free: 'price_65', essentiel: 'price_65', pro: 'price_65', premium: 'price_65' },
            },
        ],
    },
]

export const faqs = [
    {
        question: 'subscription.faq.items[0].question',
        answer: 'subscription.faq.items[0].answer',
    },
    {
        question: 'subscription.faq.items[1].question',
        answer: 'subscription.faq.items[1].answer',
    },
    {
        question: 'subscription.faq.items[2].question',
        answer: 'subscription.faq.items[2].answer',
    },
    {
        question: 'subscription.faq.items[3].question',
        answer: 'subscription.faq.items[3].answer',
    },
    {
        question: 'subscription.faq.items[4].question',
        answer: 'subscription.faq.items[4].answer',
    },
]

export const partnerLogos = [
    'Accrofun 1.png',
    'CAPVR_Logo_RondBlanc 1.png',
    'Padel 1.png',
    'Padel-Factory-3 1.png',
    'ac-loisirs 1.png',
    'bowling 1.png',
    'image-93 1.png',
    'koh-l-etang-kommando 1.png',
    'kptain-park 1.png',
    'logo-BSKS 1.png',
    'logo-gli-air 1.png',
    'logo-paintball 1.png',
    'logo-paintball-arena-59 1.png',
    'logo-paintball-med 1.png',
    'logo-parc-en-ciel 1.png',
    'logo-virtual-center 1.png',
    'logo1723734569104-1723734610 1.png',
    'zone-360-laser-game-550-400 1.png',
]
